import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { addressApi } from "../../app/slices/addressSlice";
import { IconButton, LinearProgress, Tooltip } from "@mui/material";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ContentCopy } from "@mui/icons-material";

import Filter from "../../components/Filter";
import { useFormik } from "formik";
import useFilterHandler from "../../components/filterhandler";
// import { Loader } from "lucide-react";
import Loader from "../digitalGold/Loader";

export default function Aadhar() {
  const dispatch = useDispatch();

  const [filterData, setFilterData] = useState({
    name: "",
    phone: "",
    customerRefNo: "",
  });

  const url = `/api/admin/address/list`;

  const {
    handleFilterSubmit,
    handleClearFilters,
    loader,
    results,
    apiCall,
    message,
    error,
    toastTrigger,
  } = useFilterHandler(url, filterData, setFilterData);

  // Get data from Redux
  const sliceResponse = useSelector((state) => state.address.address.data);
  const stateLoading = useSelector((state) => state.address.loading);

  // Memoize API dispatch to avoid re-fetching
  // const fetchAddressData = useCallback(() => {
  //   if (!sliceResponse) {
  //     dispatch(addressApi());
  //   }
  // }, [dispatch, sliceResponse]);

  // Use useEffect to only call API if data is not in the store
  // useEffect(() => {
  //   fetchAddressData();
  // }, [fetchAddressData]);

  useEffect(() => {
    apiCall(false);
  }, []);

  useEffect(() => {
    if (!message) return;

    // console.log("Message updated:", message);

    if (error) {
      toast.error(message);
    }
    //  else {
    //   // toast.success(message);
    // }
  }, [toastTrigger]);

  const columnHelper = createMRTColumnHelper();

  const columns = [
    // columnHelper.accessor("id", {
    //   header: "ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?._id);
    //       toast.success("Copied to clipboard!");
    //     };

    //     return (
    //       <Tooltip title={cell.row.original?._id}>
    //         <IconButton onClick={handleCopy}>
    //           <ContentCopy />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("name", {
      header: "Name",
      size: 30,
    }),
    columnHelper.accessor("mobileNumber", {
      header: "Mobile Number",
      size: 30,
    }),
    columnHelper.accessor("city", {
      header: "City",
      size: 30,
    }),
    columnHelper.accessor("state", {
      header: "State",
      size: 30,
    }),
    columnHelper.accessor("country", {
      header: "Country",
      size: 30,
    }),

    columnHelper.accessor("is_deleted", {
      header: "Is Deleted",
      size: 30,
    }),
    columnHelper.accessor("line1", {
      header: "Line 1",
      size: 30,
    }),
    columnHelper.accessor("line2", {
      header: "Line 2",
      size: 30,
    }),
    // columnHelper.accessor("mmtc_customer_ref", {
    //   header: "MMTC Customer Ref",
    //   size: 30,
    //   Cell: (cell) => (
    //     <div style={{ textAlign: "center" }}>
    //       {cell.row.original?.mmtc_customer_ref}
    //     </div>
    //   ),
    // }),
    columnHelper.accessor("statecode", {
      header: "State Code",
      size: 30,
    }),
    columnHelper.accessor("type", {
      header: "Type",
      size: 30,
    }),
    // columnHelper.accessor("userAddressId", {
    //   header: "User Address ID",
    //   size: 30,
    //   Cell: (cell) => (
    //     <div style={{ textAlign: "center" }}>
    //       {cell.row.original?.userAddressId}
    //     </div>
    //   ),
    // }),
    columnHelper.accessor("zip", {
      header: "ZIP",
      size: 30,
    }),

    // columnHelper.accessor("createdAt", {
    //   header: "Crated At",
    //   size: 30,

    // }),
    //  columnHelper.accessor("updatedAt", {
    //   header: "Updated At",
    //   size: 30,

    // }),
  ];

  return (
    <>
      <Filter
        filterData={filterData}
        onFilterSubmit={handleFilterSubmit}
        Onclear={handleClearFilters}
        page={"Addresses"}
        setFilterData={setFilterData}
      />

      {/* */}
      {/* {sliceResponse ? ( */}
      {loader ? (
        <Loader />
      ) : (
        <CustomTable
          columns={columns}
          data={results}
          loading={loader}
          permissionKey="Address"
        />
      )}
      {/* ) : (
        <LinearProgress />
      )} */}
    </>
  );
}

// import { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import CustomTable from "../../components/customTable/CustomTable";
// import { createMRTColumnHelper } from "material-react-table";
// import { addressApi } from "../../app/slices/addressSlice";
// import { IconButton, LinearProgress, Tooltip } from "@mui/material";
// import { ContentCopy, Delete } from "@mui/icons-material"; // Import the copy icon from MUI

// export default function Aadhar() {
//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(addressApi());
//   }, [dispatch]);
//   const sliceResponse = useSelector((state) => state.address.address.data);

//   const columnHelper = createMRTColumnHelper();

//   const columns = [
//     columnHelper.accessor("id", {
//       header: "ID",
//       size: 30,
//       Cell: ({ cell }) => {
//         const handleCopy = () => {
//           navigator.clipboard.writeText(cell.row.original?._id);
//           toast.success("copied to clipboard!");
//         };

//         return (
//           <Tooltip title={cell.row.original?._id}>
//             <IconButton onClick={handleCopy}>
//               <ContentCopy />
//             </IconButton>
//           </Tooltip>
//         );
//       },
//     }),
//     columnHelper.accessor("name", {
//       header: "Name",
//       size: 30,
//       // Cell: (cell) => (
//       //   <div style={{ textAlign: "center" }}>{cell.row.original?.name}</div>
//       // ),
//     }),
//     columnHelper.accessor("mobileNumber", {
//       header: "Mobile Number",
//       size: 30,
//       Cell: (cell) => (
//         <div style={{ textAlign: "center" }}>
//           {cell.row.original?.mobileNumber}
//         </div>
//       ),
//     }),
//     columnHelper.accessor("city", {
//       header: "City",
//       size: 30,
//       Cell: (cell) => (
//         <div style={{ textAlign: "center" }}>{cell.row.original?.city}</div>
//       ),
//     }),
//     columnHelper.accessor("state", {
//       header: "State",
//       size: 30,
//       Cell: (cell) => (
//         <div style={{ textAlign: "center" }}>{cell.row.original?.state}</div>
//       ),
//     }),
//     columnHelper.accessor("country", {
//       header: "Country",
//       size: 30,
//       Cell: (cell) => (
//         <div style={{ textAlign: "center" }}>{cell.row.original?.country}</div>
//       ),
//     }),
//     columnHelper.accessor("customerRefNo", {
//       header: "Customer Ref No",
//       size: 30,
//       Cell: ({ cell }) => {
//         const handleCopy = () => {
//           navigator.clipboard.writeText(cell.row.original?.customerRefNo);
//           toast.success("copied to clipboard!");
//         };
//         return (
//           <Tooltip title={cell.row.original?.customerRefNo}>
//             <IconButton onClick={handleCopy}>
//               <ContentCopy />
//             </IconButton>
//             {cell.row.original?.customerRefNo}
//           </Tooltip>
//         );
//       },
//     }),

//     columnHelper.accessor("is_deleted", {
//       header: "Is Deleted",
//       size: 30,
//       Cell: (cell) => (
//         <div style={{ textAlign: "center" }}>
//           {cell.row.original?.is_deleted}
//         </div>
//       ),
//     }),
//     columnHelper.accessor("line1", {
//       header: "Line 1",
//       size: 30,
//       Cell: (cell) => (
//         <div style={{ textAlign: "center" }}>{cell.row.original?.line1}</div>
//       ),
//     }),
//     columnHelper.accessor("line2", {
//       header: "Line 2",
//       size: 30,
//       Cell: (cell) => (
//         <div style={{ textAlign: "center" }}>{cell.row.original?.line2}</div>
//       ),
//     }),
//     columnHelper.accessor("mmtc_customer_ref", {
//       header: "MMTC Customer Ref",
//       size: 30,
//       Cell: (cell) => (
//         <div style={{ textAlign: "center" }}>
//           {cell.row.original?.mmtc_customer_ref}
//         </div>
//       ),
//     }),

//     columnHelper.accessor("statecode", {
//       header: "State Code",
//       size: 30,
//       Cell: (cell) => (
//         <div style={{ textAlign: "center" }}>
//           {cell.row.original?.statecode}
//         </div>
//       ),
//     }),
//     columnHelper.accessor("type", {
//       header: "Type",
//       size: 30,
//       Cell: (cell) => (
//         <div style={{ textAlign: "center" }}>{cell.row.original?.type}</div>
//       ),
//     }),
//     columnHelper.accessor("userAddressId", {
//       header: "User Address ID",
//       size: 30,
//       Cell: (cell) => (
//         <div style={{ textAlign: "center" }}>
//           {cell.row.original?.userAddressId}
//         </div>
//       ),
//     }),
//     columnHelper.accessor("zip", {
//       header: "ZIP",
//       size: 30,
//       Cell: (cell) => (
//         <div style={{ textAlign: "center" }}>{cell.row.original?.zip}</div>
//       ),
//     }),
//     columnHelper.accessor("is_deleted", {
//       header: "Is Deleted",
//       size: 30,
//       Cell: (cell) => (
//         <div style={{ textAlign: "center" }}>
//           {cell.row.original?.is_deleted}
//         </div>
//       ),
//     }),
//   ];

//   return (
//     <>
//       {sliceResponse ? (
//         <CustomTable columns={columns} data={sliceResponse} />
//       ) : (
//         <LinearProgress />
//       )}
//     </>
//   );
// }
